"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseApiService_1 = require("../apiServices/baseApiService/BaseApiService");
var Url_1 = require("./Url");
var getQueryForCompressedModels = function (model, typeId, assetMonitorModel) {
    var key = assetMonitorModel.split('.').join('_');
    return {
        "query": "models('" + model + "').hasProperty('models." + key + ".typeId', '" + typeId + "')"
    };
};
var getQueryForCompressedModelsWithAMModel = function (model, assetMonitorModel) {
    var key = assetMonitorModel.split('.').join('_');
    return {
        "query": "models('" + model + "').hasProperty('models." + key + ".model', '" + assetMonitorModel + "')"
    };
};
var getQueryForCompressedModelsWithVersion = function (model, typeId, assetMonitorModel, version) {
    var key = assetMonitorModel.split('.').join('_');
    return {
        "query": "models('" + model + "').hasProperty('models." + key + ".typeId', '" + typeId + "').and(hasProperty('models." + key + ".version', '" + version + "'))"
    };
};
var getQueryForModelAndType = function (model, type) {
    return {
        "query": "models('" + model + "').hasProperty('deviceType.typeId', '" + type + "')"
    };
};
var getQueryForModelContainingType = function (model, type) {
    return {
        "query": "models('" + model + "').hasProperty('deviceType.typeId', startingWith('" + type + "'))"
    };
};
var getQueryForModel = function (model) {
    return {
        "query": "models('" + model + "').orderByProperty('model.name', true)"
    };
};
var Objects = /** @class */ (function () {
    function Objects() {
    }
    Objects.prototype.saveObject = function (data) {
        return BaseApiService_1.BaseApiService.post(Url_1.url.ObjectsUrl.toString(), data);
    };
    Objects.prototype.getObject = function (objectId, modelId) {
        var url = Url_1.url.ObjectsUrl + '/' + objectId + '/models/' + modelId;
        return BaseApiService_1.BaseApiService.get(url);
    };
    Objects.prototype.updateObject = function (objectId, modelId, updatedObject) {
        var url = Url_1.url.ObjectsUrl + '/' + objectId + '/models/' + modelId;
        return BaseApiService_1.BaseApiService.put(url, updatedObject);
    };
    Objects.prototype.deleteObject = function (objectId, modelId) {
        var url = Url_1.url.ObjectsUrl + '/' + objectId + '/models/' + modelId;
        return BaseApiService_1.BaseApiService.delete(url);
    };
    Objects.prototype.getMappingsByVersion = function (modelId, typeId, version) {
        var type = typeId + '@' + version.split('.')[0];
        var url = Url_1.url.ObjectsQuery;
        var payload = getQueryForModelAndType(modelId, type);
        return BaseApiService_1.BaseApiService.post(url, payload);
    };
    Objects.prototype.getMappingsContainingTypeId = function (modelId, typeId) {
        var type = typeId + '@';
        var url = Url_1.url.ObjectsQuery;
        var payload = getQueryForModelContainingType(modelId, type);
        return BaseApiService_1.BaseApiService.post(url, payload);
    };
    Objects.prototype.getModels = function (model) {
        var url = Url_1.url.ObjectsQuery;
        var payload = getQueryForModel(model);
        return BaseApiService_1.BaseApiService.post(url, payload);
    };
    Objects.prototype.getInstanceInformationForModelType = function (pageNumber, pageSize, type) {
        var url = "" + Url_1.url.GetInstancesForModelTypePaging + type + "?count=0&pageNumber=" + pageNumber + "&pageSize=" + pageSize;
        return BaseApiService_1.BaseApiService.get(url);
    };
    Objects.prototype.queryForModel = function (model) {
        var query = { "query": "models('" + model + "')" };
        var url = Url_1.url.ObjectsQuery;
        return BaseApiService_1.BaseApiService.post(url, query);
    };
    Objects.prototype.deleteOwner = function (objectId, modelId) {
        var url = "" + Url_1.url.DeleteOwner + objectId + "/model/" + modelId;
        return BaseApiService_1.BaseApiService.delete(url);
    };
    Objects.prototype.queryForCompressedModelWithAssetMonitor = function (model, assetMonitorModel, typeId) {
        var query = getQueryForCompressedModels(model, typeId, assetMonitorModel);
        var url = Url_1.url.ObjectsQuery;
        return BaseApiService_1.BaseApiService.post(url, query);
    };
    Objects.prototype.queryForCompressedModelWithAssetMonitorModel = function (model, assetMonitorModel) {
        var query = getQueryForCompressedModelsWithAMModel(model, assetMonitorModel);
        var url = Url_1.url.ObjectsQuery;
        return BaseApiService_1.BaseApiService.post(url, query);
    };
    Objects.prototype.queryForCompressedModelWithAssetMonitorAndVersion = function (model, assetMonitorModel, typeId, version) {
        var query = getQueryForCompressedModelsWithVersion(model, typeId, assetMonitorModel, version);
        var url = Url_1.url.ObjectsQuery;
        return BaseApiService_1.BaseApiService.post(url, query);
    };
    Objects.prototype.restoreSce = function (edgeId) {
        var url = Url_1.url.RestoreSce + '/' + edgeId;
        return BaseApiService_1.BaseApiService.get(url);
    };
    Objects.prototype.createSceRestoreData = function () {
        var url = Url_1.url.CreateSceRestoreData;
        return BaseApiService_1.BaseApiService.get(url);
    };
    return Objects;
}());
exports.Objects = Objects;
//# sourceMappingURL=Objects.js.map